/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import Loading from "../ui/Loading";
import BlogGridItem from "./BlogGridItem";

export default function BlogGrid() {
  const dispatch = useDispatch();
  const { blogs, isLoading, isError, error } = useSelector(
    (state) => state.blogs
  );
  const status = useSelector((state) => state.filter);
  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);
  // console.log(filterStatus);
  // decide what to render
  let content;

  if (isLoading) content = <Loading />;
  if (!isLoading && isError) content = <div>{error}</div>;
  // content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && blogs?.length === 0) {
    content = <div>No blogs found!</div>;
  }

  // console.log(filterStatus.fliterStatus);
  if (!isError && !isLoading && blogs?.length > 0) {
    if (status.filterStatus === "saved")
      content = blogs.map((blog) => {
        if (blog.isSaved === true)
          return <BlogGridItem key={blog.id} blog={blog} />;
        else return "";
      });
    else
      content = blogs.map((blog) => <BlogGridItem key={blog.id} blog={blog} />);
  }
  // if (!isError && !isLoading && filterStatus === "saved" && blogs?.length > 0) {
  //   content = blogs.map((blog) => {
  //     if (blog.isSaved === true)
  //       return <BlogGridItem key={blog.id} blog={blog} />;
  //     else return "";
  //   });
  // }

  return (
    <main className="post-container" id="lws-postContainer">
      {content}
    </main>
    // <section className="pt-12">
    //   <section className="pt-12">
    //     <div className="grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]">
    //       {content}
    //     </div>
    //   </section>
    // </section>
  );
}
